import React from 'react';
import { Guantera } from '../../guantera';
import { GuanteraDataListClient } from './guantera-data-list-client';

export const GuanteraClient = () => {
	return (
		<Guantera isClient={true}>
			<GuanteraDataListClient />
		</Guantera>
	);
};
